export default class Storage {
    storageName: string = "";

    public constructor(storageName: string) {
        this.storageName = storageName + "@";
    }


    public save(key: string, value: any): boolean {
        let _value = JSON.stringify(value);

        localStorage.setItem(this.storageName + key, _value);

        return true;
    }

    public get(key: string): string {
        let data = localStorage.getItem(this.storageName + key);
        let _data = '';
        try {
            _data = JSON.parse(data);

        } catch (e) {
            console.error(e);
        }

        return _data || null;
    }

    public delete(key: string): void {
        localStorage.removeItem(this.storageName + key);
    }

}